import { Component, OnInit, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { TexteService } from 'src/app/core/services/texte.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { IContact } from 'src/app/core/interfaces/contact.interface';
import { ToolboxService } from 'src/app/core/services/toolbox.service';
import { ITypesSelection } from 'src/app/core/interfaces/types-selection.interface';

@Component({
    selector: 'app-contact-form',
    templateUrl: './contact-form.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContactFormComponent implements OnInit, OnChanges {

  @Input() typesSelected: ITypesSelection;
  @Input() indicatifs: number[];
  public contactForm: FormGroup;

  constructor(
    public texteService: TexteService,
    private toolboxService: ToolboxService
  ) { }

  ngOnInit(): void {
    this.buildForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.indicatif != null && !changes.indicatif.firstChange && this.indicatifs.length > 0) {
      this.contactForm.get('indicatif').setValue(this.indicatifs[0]);
      this.contactForm.get('indicatif2').setValue(this.indicatifs[0]);
    }
  }

  private buildForm() {
    this.contactForm = new FormGroup({
      telephone: new FormControl('', [Validators.required, this.toolboxService.telValidator()]),
      telephone2: new FormControl('', this.toolboxService.telValidator()),
      email: new FormControl('', [Validators.required, Validators.email]),
      recontact: new FormControl('', Validators.required),
    });

    if (this.typesSelected.situation.code === 'INT') {
      this.contactForm.addControl('indicatif', new FormControl(this.indicatifs.length > 0 ? this.indicatifs[0] : '',
        [this.toolboxService.indicatifValidator(), Validators.required]));
      this.contactForm.addControl('indicatif2', new FormControl(this.indicatifs.length > 0 ? this.indicatifs[0] : '',
        [this.toolboxService.indicatifValidator(), Validators.required]));
    }
  }

  public isValid(): boolean {
    return this.contactForm.valid;
  }

  public getForm(): IContact {
    let tel: string;
    let tel2: string;

    if (this.typesSelected.situation.code === 'INT' &&
      !this.toolboxService.stringIsNullOrWhiteSpace(this.contactForm.get('telephone').value)) {
      tel = '+' + this.contactForm.get('indicatif').value + ' ' + this.contactForm.get('telephone').value;
    } else {
      tel = this.contactForm.get('telephone').value;
    }

    if (this.typesSelected.situation.code === 'INT' &&
      !this.toolboxService.stringIsNullOrWhiteSpace(this.contactForm.get('telephone2').value)) {
      tel2 = '+' + this.contactForm.get('indicatif2').value + ' ' + this.contactForm.get('telephone2').value;
    } else {
      tel2 = this.contactForm.get('telephone2').value;
    }

    return {
      telephone: tel,
      telephone2: tel2,
      email: this.contactForm.get('email').value,
      recontact: this.contactForm.get('recontact').value,
      isContactMatin: this.contactForm.get('recontact').value === 'am' ? true : false,
    } as IContact;
  }
}
